import React from 'react';

const SvgSg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SG_svg__b" fill="#fff">
        <use xlinkHref="#SG_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#E12237" mask="url(#SG_svg__b)" d="M0 0h28v10.667H0z" />
      <path
        d="M9.165 2.21a3.333 3.333 0 1 0 0 6.248 4 4 0 1 1 0-6.248zM7.333 5.332a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM8.667 8a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm2.666 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm1.334-2.667a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm-2.667-2A.667.667 0 1 1 10 2a.667.667 0 0 1 0 1.333z"
        fill="#FFF"
        mask="url(#SG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgSg;
